<ws-modal-wrapper
    [headerLabel]="title"
    (save)="applyAll()"
    (auxButton)="applySome()"
    (cancel)="cancel()"
    acceptLabel="Apply All"
    [auxButtonLabel]="isCheckboxesEnabled ? 'Apply Selected' : null"
    [cancelLabel]="params.disableApplyAll ? 'Close' : 'Cancel'"
    [disableAuxButton]="!atLeastOneRowSelected || params.disableApplyAll"
    [disableSave]="params.disableApplyAll"
>
    <div class="card-container overflow-auto">
        <div class="d-flex flex-column">
            @if (billCard) {
                <div>
                    <idp-detail-card [disableApplyAll]="params.disableApplyAll" [detail]="billCard" [isBill]="true">
                    </idp-detail-card>
                </div>
            }
            @if (payments) {
                <div class="d-flex flex-wrap">
                    @for (payment of payments; track payment) {
                        <idp-detail-card [detail]="payment" [disableApplyAll]="params.disableApplyAll">
                        </idp-detail-card>
                    }
                </div>
            }
        </div>
    </div>
</ws-modal-wrapper>
